import LineIcon from "@assets/images/line.svg";
import RefreshIcon from "@assets/images/refresh-primary.svg";
import {
  Box,
  Button,
  Collapse,
  Divider,
  FormControlLabel,
  Grid,
  GridSize,
  Radio,
  RadioGroup
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import OrderStatus from "@saleor/changeOrderExport/components/OrderStatus/OrderStatus";
import AutoSuggestionMultipleSelect from "@saleor/components/AutoSuggestionMutipleSelect";
import DatePicker from "@saleor/components/DatePicker";
import { FormSpacer } from "@saleor/components/FormSpacer";
import MyTypography from "@saleor/components/MyTypography";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { SingleTextField } from "@saleor/components/SingleTextField";
import TextInputDisable from "@saleor/components/TextInputDisable";
import usePendingOrderCustomer from "@saleor/hooks/usePendingOrderCustomer";
import { mapEdgesToItems } from "@saleor/utils/maps";
import classNames from "classnames";
import moment from "moment-timezone";
import React, { useEffect, useMemo, useState } from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage, useIntl } from "react-intl";

import ModalAddress from "../ModalAddress";
import { FIELD_TYPE } from "../OrderFilterSectionAdmin/constant";
import useStyles from "../OrderFilterSectionAdmin/styles";

export interface OrderFilterSectionProps {
  handleChangeFilter?: (filterObj: any) => void;
  onResetForm: () => void;
  message: JSX.Element | string;
  listOrder: any[];
  loading?: boolean;
}

const OrderFilterSectionCustomer: React.FC<OrderFilterSectionProps> = ({
  handleChangeFilter,
  onResetForm,
  message,
  listOrder,
  loading
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const [reRender, setRender] = useState<boolean>(false);
  const [openModalShipTo, setOpenModalShipTo] = useState<boolean>(false);
  const {
    formik,
    isOpen,
    setIsOpen,
    handleCleanForm,
    formData,
    ArrowIconComponent,
    getRequireAttentionSoldTo,
    fetchRequireAttentionSoldTo,
    loadingRequireAttentionSoldTo,
    getRequireAttentionMaterial,
    fetchRequireAttentionMaterial,
    loadingRequireAttentionMaterial,
    shipToData,
    isClean
  } = usePendingOrderCustomer({ handleChangeFilter });

  useEffect(() => {
    if (listOrder?.length) {
      setIsOpen(false);
    }
  }, [listOrder]);

  const getTextError = field => {
    if (!formik.errors[field]?.lte && !formik.errors[field]?.gte) {
      return <div className={classes.textError}>{formik.errors[field]}</div>;
    }
  };

  const getTextErrorDatePick = field => {
    if (formik.errors[field]?.lte) {
      return (
        <div className={classes.textError}>{formik.errors[field]?.lte}</div>
      );
    }
    if (formik.errors[field]?.gte) {
      return (
        <div className={classes.textError}>{formik.errors[field]?.gte}</div>
      );
    }
  };

  const isDisabled = useMemo(
    () =>
      !(
        formik.values.poNo ||
        formik.values.soNo ||
        (formik.values.createDate.gte && formik.values.createDate.lte) ||
        (formik.values.requestDeliveryDate.lte &&
          formik.values.requestDeliveryDate.gte)
      ),
    // if (!formik.values.createDate.gte || !formik.values.createDate.lte) {
    //   return true;
    // }
    // return !formik.dirty;
    [formik.values, formik.dirty]
  );

  const handleResetForm = () => {
    setRender(prevState => !prevState);
    handleCleanForm();
    onResetForm();
  };

  const mappingDataSuggestMultipleSelect = name => {
    if (name === "soldTo") {
      return {
        fetchDataSuggestions: fetchRequireAttentionSoldTo,
        loadingDataSuggestion: loadingRequireAttentionSoldTo,
        getDataSuggestions: getRequireAttentionSoldTo,
        searchField: "soldTo",
        dataOptions:
          mapEdgesToItems(fetchRequireAttentionSoldTo?.exportSoldTos)?.map(
            data => ({
              title: `${data.code} - ${data.name}`,
              value: data.code
            })
          ) || []
      };
    }

    if (name === "materialNoMaterialDescription") {
      return {
        fetchDataSuggestions: fetchRequireAttentionMaterial,
        loadingDataSuggestion: loadingRequireAttentionMaterial,
        getDataSuggestions: getRequireAttentionMaterial,
        searchField: "material",
        isCheckingRole: true,
        dataOptions:
          mapEdgesToItems(
            fetchRequireAttentionMaterial?.filterRequireAttentionMaterial
          )?.map(data => ({
            title: `${data.code} - ${data.descriptionEn}`,
            value: data.code
          })) || []
      };
    }
  };

  // const minDate = useCallback(data => moment(data.lte).subtract(29, "days"), [
  //   formik.values.soldTo.length
  // ]);
  //
  // const maxDate = useCallback(data => moment(data.gte).add(29, "days"), [
  //   formik.values.soldTo.length
  // ]);

  useEffect(() => {
    if (formik.values.createDate.lte) {
      if (formik.values.soldTo.length) {
        const maxDiff = 89;
        const diff = moment(formik.values.createDate.lte).diff(
          moment(formik.values.createDate.gte),
          "days"
        );
        if (Math.abs(diff) > maxDiff) {
          const newLte = moment(formik.values.createDate.gte).add(
            maxDiff,
            "day"
          );
          formik.setFieldValue("createDate.lte", newLte);
        }
      }
    }
  }, [formik.values.createDate.gte]);

  useEffect(() => {
    if (formik.values.createDate.gte) {
      if (formik.values.soldTo.length) {
        const maxDiff = 89;
        const diff = moment(formik.values.createDate.gte).diff(
          moment(formik.values.createDate.lte),
          "days"
        );
        if (Math.abs(diff) > maxDiff) {
          const newGte = moment(formik.values.createDate.lte).subtract(
            maxDiff,
            "day"
          );
          formik.setFieldValue("createDate.gte", newGte);
        }
      }
    }
  }, [formik.values.createDate.lte]);

  useEffect(() => {
    if (formik.values.requestDeliveryDate.lte) {
      if (formik.values.soldTo.length) {
        const maxDiff = 89;
        const diff = moment(formik.values.requestDeliveryDate.lte).diff(
          moment(formik.values.requestDeliveryDate.gte),
          "days"
        );
        if (Math.abs(diff) > maxDiff) {
          const newLte = moment(formik.values.requestDeliveryDate.gte).add(
            maxDiff,
            "day"
          );
          formik.setFieldValue("requestDeliveryDate.lte", newLte);
        }
      }
    }
  }, [formik.values.requestDeliveryDate.gte]);

  useEffect(() => {
    if (formik.values.requestDeliveryDate.gte) {
      if (formik.values.soldTo.length) {
        const maxDiff = 89;
        const diff = moment(formik.values.requestDeliveryDate.gte).diff(
          moment(formik.values.requestDeliveryDate.lte),
          "days"
        );
        if (Math.abs(diff) > maxDiff) {
          const newGte = moment(formik.values.requestDeliveryDate.lte).subtract(
            maxDiff,
            "day"
          );
          formik.setFieldValue("requestDeliveryDate.gte", newGte);
        }
      }
    }
  }, [formik.values.requestDeliveryDate.lte]);

  const handleChangeDate = (e, child, type) => {
    formik.handleChange({
      target: {
        name: `${child.name}.${type}`,
        value: e.target.value
      }
    });
  };

  const handleOpenShipTo = () => {
    setOpenModalShipTo(true);
  };

  const handleCloseShipTo = () => {
    setOpenModalShipTo(false);
  };

  const handleApplyAddress = (shiping, shippingAddr) => {
    formik.setFieldValue("shipTo.code", shiping);
    formik.setFieldValue("shipTo.name", shippingAddr);
  };

  const renderItem = (
    <Grid className={classes.searchBox} container spacing={3}>
      {formData.map((child, key) => {
        const renderChild = (children: JSX.Element) => (
          <Grid
            item
            md={child.md ? (child.md as GridSize) : 2}
            sm={child.sm ? (child.sm as GridSize) : 6}
            key={key}
          >
            <div
              className={classNames({
                [classes.datePicker]: child.type === FIELD_TYPE.DATEPICKER
              })}
              style={{ position: "relative" }}
            >
              <MyTypography
                variant={"subtitle3"}
                className={classNames({
                  [classes.wrapShipToBtn]: child.isShipTo
                })}
              >
                {child.title}
                {child.required && <span className={classes.required}>*</span>}
                {child.subTitle && (
                  <MyTypography variant="caption" className={classes.subTitle}>
                    {child.subTitle}
                  </MyTypography>
                )}
                {child.iconRight && formik.values[child.name].name && (
                  <SVG
                    src={child.iconRight}
                    onClick={handleOpenShipTo}
                    className={classes.iconEditShipTo}
                  />
                )}
              </MyTypography>
              {children}
              {getTextError(child.name)}
            </div>
          </Grid>
        );
        if (child.type === FIELD_TYPE.EMPTY) {
          return renderChild(<></>);
        }
        if (child.type === FIELD_TYPE.DISABLED_TEXT) {
          return renderChild(
            <TextInputDisable value={formik.values[child.name] || ""} />
          );
        }
        if (child.type === FIELD_TYPE.SINGLE_INPUT) {
          return renderChild(
            <SingleTextField
              name={child.name}
              id={child.name}
              value={formik.values[child.name]}
              onChange={formik.handleChange}
              placeholder={child.placeholder}
              error={!!formik.errors[child.name]}
              maxLengthProps={child?.maxLength ? child.maxLength : undefined}
            />
          );
        }
        if (child.type === FIELD_TYPE.SINGLE_SELECT) {
          return renderChild(
            <SingleSelectField
              className={classes.selectField}
              menuListCustomStyle={{
                overflowY: "auto"
              }}
              choices={child.options}
              name={child.name}
              id={child.name}
              onChange={formik.handleChange}
              value={formik.values[child.name]}
              placeholder={child.placeholder}
              error={!!formik.errors[child.name]}
            />
          );
        }

        if (child.type === FIELD_TYPE.MULTIPLE_SELECT) {
          return renderChild(
            <OrderStatus
              disableIndeterminate
              showChipDeleteButton={false}
              choices={child.options}
              name={child.name}
              id={child.name}
              value={formik.values[child.name]}
              onChange={formik.handleChange}
              showCircularIcon={false}
              isClean={isClean}
              placeholder={child.placeholder}
              listItemClass={classes.listItemClass}
              numberItemDisplay={2}
              error={!!formik.errors[child.name]}
            />
          );
        }

        if (child.type === FIELD_TYPE.BUTTON_SHIP_TO) {
          if (formik.values[child.name].name) {
            return renderChild(
              <TextInputDisable value={formik.values[child.name].name || ""} />
            );
          }
          return renderChild(
            <Button
              variant="outlined"
              color="secondary"
              className={classNames(classes.shipToBtn)}
              onClick={handleOpenShipTo}
              name="shipToButton"
              id="shipToButton"
            >
              <MyTypography variant="body3">
                {intl.formatMessage({
                  defaultMessage: "เลือกสถานที่จัดส่งสินค้า"
                })}
              </MyTypography>
            </Button>
          );
        }
        if (child.type === FIELD_TYPE.MULTIPLE_SUGGESTION_INPUT) {
          const dataSuggest = mappingDataSuggestMultipleSelect(child.name);

          return renderChild(
            <AutoSuggestionMultipleSelect
              emptyBoxClasses={
                child.name === "materialNoMaterialDescription" &&
                classes.emptyBox
              }
              suggestBoxClasses={
                child.name === "materialNoMaterialDescription" &&
                classes.suggestionBox
              }
              maxCount={child.name === "materialNoMaterialDescription" ? 1 : 10}
              isShowSelected={child.isShowSelected}
              reRender={reRender}
              headerText={child.headerText}
              message={child.message}
              keyFilterApi={child.keyFilterApi}
              name={child.name}
              id={child.name}
              placeholder={child.placeholder}
              {...dataSuggest}
              getByValue
              handleSelectedSearch={value => {
                formik.handleChange({
                  target: {
                    name: child.name,
                    value
                  }
                });
              }}
            />
          );
        }

        if (child.type === FIELD_TYPE.RADIO_GROUP) {
          return renderChild(
            <RadioGroup
              className={classes.radioGroup}
              aria-labelledby="demo-controlled-radio-buttons-group"
              name={child.name}
              id={child.name}
              value={formik.values[child.name]}
              onChange={formik.handleChange}
            >
              {child.options?.map((o, oKey) => (
                <FormControlLabel
                  key={`radio${oKey}`}
                  id={`radio${oKey}`}
                  value={o.value}
                  control={<Radio />}
                  label={
                    <MyTypography variant={"body3"}>{o.label}</MyTypography>
                  }
                />
              ))}
            </RadioGroup>
          );
        }
        if (child.type === FIELD_TYPE.DATEPICKER) {
          return renderChild(
            <>
              <Box display="flex" justifyItems="center" alignItems="center">
                <DatePicker
                  type="gte"
                  dateRange={30}
                  name={`${child.name}`}
                  id={`start${child.name}`}
                  disableManualInput
                  value={formik.values[child.name]?.gte || ""}
                  onChange={e => {
                    handleChangeDate(e, child, "gte");
                  }}
                  error={!!formik.errors[child.name]?.gte}
                  format="YYYY-MM-DD"
                  maxDate={
                    formik.values[child.name].lte
                      ? moment(formik.values[child.name].lte)
                      : undefined
                  }
                  minDate={undefined}
                />
                <Box px={1} display="flex" alignItems="center">
                  <SVG src={LineIcon} width={12} height={2} />
                </Box>
                <DatePicker
                  type="lte"
                  dateRange={30}
                  name={`${child.name}`}
                  id={`end${child.name}`}
                  disableManualInput
                  value={formik.values[child.name]?.lte || ""}
                  error={!!formik.errors[child.name]?.lte}
                  onChange={e => {
                    handleChangeDate(e, child, "lte");
                  }}
                  format="YYYY-MM-DD"
                  maxDate={undefined}
                  minDate={
                    formik.values[child.name].gte
                      ? moment(formik.values[child.name].gte)
                      : undefined
                  }
                />
              </Box>
              <Box className={classes.wrapDatePickerError}>
                <Box className={classes.datePickerError}>
                  {getTextErrorDatePick(child.name)}
                </Box>
                <Box className={classes.empty}></Box>
                <Box className={classes.datePickerError}>
                  {getTextErrorDatePick(child.name)}
                </Box>
              </Box>
            </>
          );
        }
      })}
    </Grid>
  );

  return (
    <>
      <div className={classes.wrapper}>
        <Box className={classes.root}>
          <Grid
            className={classes.header}
            container
            onClick={() => setIsOpen(!isOpen)}
          >
            <MyTypography variant="h6">
              <FormattedMessage defaultMessage="ค้นหา Pending Order" />
            </MyTypography>
            <ArrowIconComponent className={classes.arrowIcon} />
          </Grid>
          <Collapse in={isOpen}>
            {renderItem}
            <Box className={classes.divider}>
              <FormSpacer />
              <Divider />
            </Box>
            <Box className={classes.bottomBar} ml={3}>
              {message}
              <Box className={classes.flex}>
                <Box mr={2}>
                  <Button
                    className={classes.resetButton}
                    variant={"outlined"}
                    color={"secondary"}
                    disabled={!formik.dirty}
                    onClick={handleResetForm}
                    id="resetButton"
                    name="resetButton"
                  >
                    <SVG
                      src={RefreshIcon}
                      className={classes.icon}
                      width={16}
                      height={16}
                    />
                    <FormattedMessage defaultMessage="ล้างข้อมูล" />
                  </Button>
                </Box>
                <Box>
                  <Button
                    className={classes.actionButton}
                    variant={"contained"}
                    disabled={isDisabled || loading}
                    color={"secondary"}
                    onClick={formik.submitForm}
                    name="submitButton"
                    id="submitButton"
                  >
                    <SearchIcon style={{ fontSize: "18px" }} />
                    <FormattedMessage defaultMessage="ค้นหา" />
                  </Button>
                </Box>
              </Box>
            </Box>
          </Collapse>
        </Box>
      </div>
      <ModalAddress
        onClose={handleCloseShipTo}
        visible={openModalShipTo}
        address={shipToData}
        handleApplyAddress={handleApplyAddress}
        defaultAddress={formik.values.shipTo.code}
      />
    </>
  );
};

export default OrderFilterSectionCustomer;
